import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AuthGuard} from "../guards/auth.guard";
import {VendorsComponent} from "./vendors.component";
import {VendorsImporterComponent} from "./vendors-importer/vendors-importer.component";

const routes: Routes = [
  {
    path: 'vendors',
    component: VendorsComponent,
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'vendors/importer',
    component: VendorsImporterComponent,
    canActivate: [
      AuthGuard
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VendorsRoutingModule { }
